import { UtilityOptions } from "@opengov/components-nav-bar";

import { Routes } from "./routesUtils";

export type GetSettingsOptionsParams = {
  entitySubdomain: string;
};

export const getSettingsOptions = ({ entitySubdomain }: GetSettingsOptionsParams): UtilityOptions => {
  return {
    menuSections: [],
    iconOnClickOverride: () => {
      window.location.href = Routes.entitySettings(entitySubdomain);
    },
  };
};
